module.exports = __webpack_public_path__ + "img/home-4.64fb2736.png";